<template>
  <div class="wli_row wli_list_panel">
    <div class="wli_row">
      <div>
        <icon :icon="icon" v-if="icon" size="sm"></icon>
        {{ product.name }}
      </div>
      <div>
        <div v-if="product.price_initial > 0">
          eenmalig
          <span :class="{ wli_discounted: (product.price_initial_discount != null) }">
                        {{ toCurrencyEur(product.price_initial) }}
                    </span>
          <span v-if="product.price_initial_discount != null">
                        {{ toCurrencyEur(product.price_initial_discount) }}
                    </span>
        </div>
        <div v-if="product.price_monthly > 0">
          {{ contractDuration }} x {{ toCurrencyEur(product.price_monthly) }}
        </div>

        <div v-if="(product.price_initial === 0 || product.price_initial == null) && (product.price_monthly === 0 || product.price_monthly == null)">
          inbegrepen
        </div>
      </div>
    </div>
    <div class="wli_row" v-if="product.discount_duration > 0">
      <span>Korting op {{ product.name }}</span>
      <div>
        <div>
          {{ product.discount_duration }} x
          {{ toCurrencyEur(product.price_monthly - product.price_monthly_discount) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from 'vue-elements/icon/Icon.vue';

export default {
  props:[
    'product',
    'contractDuration',
    'icon'
  ],
  components: {
    Icon
  },
}
</script>
